import React, { useEffect, useState } from 'react';
import api from '../services/api';

const UserDashboard = () => {
  const [content, setContent] = useState([]);

  useEffect(() => {
    api.getUserContent().then(setContent).catch(err => console.error(err));
  }, []);

  return (
    <div>
      <h2>Your Content</h2>
      <ul>
        {content.map(item => (
          <li key={item.id}>{item.title}</li>
        ))}
      </ul>
    </div>
  );
};

export default UserDashboard;
